import { Questions as component } from './component'
import { RootState } from 'stores/index'
import { connect } from 'react-redux'
import * as actions from './actions'
import { getSubmissionStatus } from 'stores/selectors'

const mapStateToProps = (state: RootState) => ({
  selectedAnswers: state.selectedAnswers,
  submissionStatus: getSubmissionStatus(state)
})

// @ts-ignore
export const Questions = connect(
  mapStateToProps,
  { ...actions }
)(component)
